import React, {useEffect,useState} from 'react';
import { Link, withRouter } from "react-router-dom"
import {Input,Form,FormGroup,Label,Row} from "reactstrap";
import { getStorageUser } from '../../helpers/api_helper';
import Select from 'react-select';
import { resourcesGeofence,resourcesConfigurationRoute } from '../../helpers/backend_helper';

const Columns = (id,handlerOnChange) => {
	const authUser = getStorageUser();
	const [geofences, setGeofences] = useState([]);

	useEffect(() => {
		const getGeodences = async() =>{
			const response = await resourcesGeofence('show',{},id);
    		setGeofences(response.geofences);
		}
		getGeodences();
    }, [])

	const save = async(item) =>{
		const response= await resourcesConfigurationRoute('post',item)
		if(response.status){
			handlerOnChange(item.id);
		}
	}

	let columns = [
		{
			id: 'name',
			name: 'Configuración',
			selector: row => row.name,
			wrap: true,
		},
		{
			id: 'value',
			name: 'Valor',
			cell: row => (
				<div className="col-12" >
					{row.type=='geofences' ?
							<div className="col-sm-6">
								<Select
									className="basic-single"
									classNamePrefix="select"
									getOptionLabel={(option) => `${option.name}`}
									getOptionValue={(option) => `${option.id}`}
									name="geocerca"
									options={geofences}
									onChange={ e => handlerOnChange(e, 'geocerca') }
								/>
							</div>
						:
						<div className="col-sm-6">
							<input className="form-control" name="max_speed" type={row.type} onChange={ e => handlerOnChange(row.id,e) } value={row.value ? row.value:''}/>
						</div>
					}
				</div>
			),
		},
		
		{
			id: 'actions',
			name: 'Acciones',
			button: true,
			cell: row => (
				<div className="d-flex justify-content-between">
					<div className="p-2">
						<button className="btn btn-primary btn-sm" disabled={row.is_modified ? false:true} title='Guardar Configuración' onClick={() => save(row)}><i className="fas fa-save"></i></button>
					</div>
				</div>
				),
		}
		];
	return columns;
}

export default Columns;